﻿window.katexproxy = function () {
	var instance = {
		init: function (elid) {
			const el = document.getElementById(elid);
			if (el)
				katex.render(el.textContent, el, { throwOnError: false, trust: true });
			document.querySelectorAll('span[data-icon]').forEach(el => el.innerHTML = atob(el.getAttribute('data-icon')));
		},
	};

	return instance;
}();